const main = async () => {
  const { default: loader, appSettings } = await import(window.WishlistKingAppLoaderURL);

  loader.load({
    name: 'wishlist-button-block',
    type: 'lit-component',
    url: appSettings.assets.componentWishlistButtonBlockJs,
    dependencies: [
      {
        url: appSettings.assets.componentWishlistButtonBlockCss,
        order: 5,
      },
    ],
  });
};

if (window.WishlistKingAppLoaderURL) {
  main();
}
